<template>
  <div class="right"><slot /></div>
</template>
<script>
export default {};
</script>

<style scoped>
.right {
  display: flex;
  align-items: center;
  gap: 15px;
}
.right > * {
  white-space: nowrap;
}
</style>
